module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Número de alunos de graduação participantes*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.numAlunosGraduacao),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "numAlunosGraduacao", $$v)
      },
      expression: "projetoPesquisa.numAlunosGraduacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field-integer', {
    attrs: {
      "label": "Número de alunos de especialização participantes*",
      "properties": {
        rules: _vm.obrigatorio.concat( _vm.numerico)
      }
    },
    model: {
      value: (_vm.projetoPesquisa.numAlunosEspecializacao),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "numAlunosEspecializacao", $$v)
      },
      expression: "projetoPesquisa.numAlunosEspecializacao"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui vínculo com a iniciação científica*"
    },
    model: {
      value: (_vm.projetoPesquisa.vinculoIniciacaoCientifica),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "vinculoIniciacaoCientifica", $$v)
      },
      expression: "projetoPesquisa.vinculoIniciacaoCientifica"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "v-radio-group_label",
    attrs: {
      "label": "Possui interface com outras áreas*"
    },
    model: {
      value: (_vm.projetoPesquisa.interfaceOutrasAreas),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "interfaceOutrasAreas", $$v)
      },
      expression: "projetoPesquisa.interfaceOutrasAreas"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Sim",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Não",
      "value": false
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Áreas de interface com o projeto*")])])], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Desenvolvimento Tecnológico"
    },
    model: {
      value: (_vm.projetoPesquisa.areaDesenvTec),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaDesenvTec", $$v)
      },
      expression: "projetoPesquisa.areaDesenvTec"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Ensino"
    },
    model: {
      value: (_vm.projetoPesquisa.areaEnsino),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaEnsino", $$v)
      },
      expression: "projetoPesquisa.areaEnsino"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Extensão"
    },
    model: {
      value: (_vm.projetoPesquisa.areaExtensao),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaExtensao", $$v)
      },
      expression: "projetoPesquisa.areaExtensao"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.projetoPesquisa.interfaceOutrasAreas === true) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Outras"
    },
    model: {
      value: (_vm.projetoPesquisa.areaOutros),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "areaOutros", $$v)
      },
      expression: "projetoPesquisa.areaOutros"
    }
  })], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [(_vm.projetoPesquisa.areaOutros === true) ? _c('v-text-field', {
    attrs: {
      "label": "Especifique*",
      "counter": "100",
      "rules": _vm.obrigatorio.concat( _vm.max100caracteres)
    },
    model: {
      value: (_vm.projetoPesquisa.especAreaOutros),
      callback: function($$v) {
        _vm.$set(_vm.projetoPesquisa, "especAreaOutros", $$v)
      },
      expression: "projetoPesquisa.especAreaOutros"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        return _vm.editarProjetoPesquisa()
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-981ed528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/editar-outras-informacoes.vue
// module id = 915
// module chunks = 0